export default "__VITE_ASSET__CtPOiruG__"